<template>
    <div>
        <!-- Conversion Rates -->
        <div class="conversion-rates">
            <div class="conversion-rate">
                <label for="usd-to-gbp">USD to GBP:</label>
                <input type="number" id="usd-to-gbp" v-model="usdToGbp" class="form-control">
            </div>
            <div class="conversion-rate">
                <label for="yen-to-gbp">JPY to GBP:</label>
                <input type="number" id="jyp-to-gbp" v-model="yenToGbp" class="form-control">
            </div>
            <div class="conversion-rate">
                <label for="aud-to-gbp">AUD to GBP:</label>
                <input type="number" id="aud-to-gbp" v-model="audToGbp" class="form-control">
            </div>
            <div class="actions">
                <button @click.prevent="resetToDefault" class="btn btn-itg-dark">Reset To Default</button>
            </div>
        </div>
        <!-- / Conversion Rates -->

        <div v-if="!allConvertedExpensesInGbp.length">
            <div class="alert alert-info">
                No expenses to display.
            </div>
        </div>

        <el-tabs v-if="allConvertedExpensesInGbp.length" v-model="propertyTab">
            <el-tab-pane label="Summary" name="summary">
                <div class="summary">
                    <div class="row">
                        <!-- <div class="col-md-3">
                            <stat title="Total Expenses Combined" :value="totalExpensesInGbp"></stat>
                        </div> -->
                        <div class="col-md-12">
                            <stat title="Total Expenses Combined" :value="totalExpensesInJpy"></stat>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-3">
                            <stat title="GBP Expenses" :value="gbpExpensesSummed"></stat> 
                        </div>
                        <div class="col-md-3">
                            <stat title="JPY Expenses" :value="jpyExpensesSummed"></stat> 
                        </div>
                        <div class="col-md-3">
                            <stat title="AUD Expenses" :value="audExpensesSummed"></stat> 
                        </div>
                        <div class="col-md-3">
                            <stat title="USD Expenses" :value="usdExpensesSummed"></stat> 
                        </div>
                    </div>
                </div>
            </el-tab-pane>

            <el-tab-pane :lazy="true" label="Expenses Over Time" name="expenses-over-time">


                <!-- Expenses Over Time Chart -->
                <v-chart :forceFit="true" renderer="svg" :height="expensesOverTimeGraphHeight"
                    :data="expensesOverTimeData" :scale="expensesOverTimeGraphScale">
                    <v-tooltip />
                    <v-axis />
                    <v-bar position="day*GBP" />
                </v-chart>
                <!-- / Expenses Over Time Chart -->

                <!-- Expenses Over Time Table -->
                <table class="table mb-0 table-centered">
                    <thead class="thead-light">
                        <tr>
                            <th>Date</th>
                            <th>Total Expenses</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="expense in expensesOverTimeData">
                            <th scope="row">{{ expense.label }}</th>
                            <td>{{ expense.total_in_gbp_formatted }}</td>
                        </tr>
                    </tbody>
                </table>
                <!-- / Expenses Over Time Table -->
            </el-tab-pane>
            <!-- <el-tab-pane label="Expenses By Ticket" name="expenses-by-ticket"></el-tab-pane> -->
            <el-tab-pane :lazy="true" label="Expenses By Primary Agent" name="expenses-by-primary-agent">

                <!-- Expenses By Primary Agent -->
                <v-chart :forceFit="true" renderer="svg" :height="expensesByPrimaryAgentGraphHeight"
                    :data="expensesByPrimaryAgent" :scale="expensesByPrimaryAgentGraphScale">
                    <v-tooltip />
                    <v-axis />
                    <v-bar position="name*GBP" />
                </v-chart>
                <!-- / Expenses By Primary Agent -->

            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import stat from '../../../../../components/widgets/stat';
import _ from 'lodash';

export default {
    data() {
        return {
            propertyTab: 'summary',

            yenToGbpDefault: 0.0055,
            usdToGbpDefault: 0.82,
            audToGbpDefault: 0.52,

            yenToGbp: 0.0055,
            usdToGbp: 0.82,
            audToGbp: 0.52,

            expensesOverTimeGraphHeight: 350,
            expensesOverTimeGraphScale: [{
                dataKey: 'GBP',
            }],

            expensesByPrimaryAgentGraphHeight: 350,
            expensesByPrimaryAgentGraphScale: [{
                dataKey: 'GBP',
            }]
        }
    },

    components: { stat },

    methods: {
        convertExpenseIntoGbp(expense) {
            if (expense.currency === 'GBP') {
                return expense.amount;
            }

            if (expense.currency === 'USD') {
                return expense.amount * this.usdToGbp;
            }

            if (expense.currency === 'JPY') {
                return expense.amount * this.yenToGbp;
            }

            if (expense.currency === 'AUD') {
                return expense.amount * this.audToGbp;
            }
        },

        convertExpenseIntoJpy(expense) {
            if (expense.currency === 'JPY') {
                return expense.amount;
            }

            let intoGbp = this.convertExpenseIntoGbp(expense);
            return intoGbp / this.yenToGbp;
        },

        determineTotalExpensesForDayInGbp(day) {
            let total = 0;
            _.each(this.allConvertedExpensesInGbp, expense => {
                if (moment.utc(expense.created_at).tz(window.itgTimezone).format('YYYY-MM-DD') === day) {
                    total += expense.converted_amount;
                }
            });
            return total;
        },

        determineTotalExpensesForPrimaryAgentInGbp(agent) {
            let total = 0;
            let tickets = _.filter(this.ticketWithExpensesConvertedIntoGbp, { agent_id: agent.id });
            _.each(tickets, ticket => {
                _.each(ticket.ticket_expenses, expense => {
                    total += expense.converted_amount;
                });
            });
            return total;
        },

        resetToDefault() {
            this.yenToGbp = this.yenToGbpDefault;
            this.usdToGbp = this.usdToGbpDefault;
            this.audToGbp = this.audToGbpDefault;
        }
    },

    computed: {
        ...mapGetters('reportEditor', {
            results: 'results',
            agents: 'agents'
        }),

        agentsToShow() {
            return _.filter(this.agents, agent => {
                return agent.is_cx;
            });
        },

        ticketsWithExpenses() {
            return _.filter(this.results, ticket => {
                return ticket.ticket_expenses && ticket.ticket_expenses.length > 0;
            });
        },

        ticketWithExpensesConvertedIntoGbp() {
            return _.map(this.ticketsWithExpenses, ticket => {
                return {
                    ...ticket,
                    ticket_expenses: _.map(ticket.ticket_expenses, expense => {
                        return {
                            ...expense,
                            converted_amount: this.convertExpenseIntoGbp(expense),
                            converted_currency: 'GBP'
                        }
                    })
                }
            });
        },

        ticketWithExpensesConvertedIntoJpy() {
            return _.map(this.ticketsWithExpenses, ticket => {
                return {
                    ...ticket,
                    ticket_expenses: _.map(ticket.ticket_expenses, expense => {
                        return {
                            ...expense,
                            converted_amount: this.convertExpenseIntoJpy(expense),
                            converted_currency: 'JPY'
                        }
                    })
                }
            });
        },

        totalExpensesInGbp() {
            return '£' + Math.round(_.sumBy(this.allConvertedExpensesInGbp, 'converted_amount')) / 100;
        },

        totalExpensesInJpy() {
            return '¥' + Math.round(_.sumBy(this.allConvertedExpensesInJpy, 'converted_amount') / 100);
        },

        gbpExpensesSummed() {
            let summed = 0;

            _.each(this.ticketWithExpensesConvertedIntoGbp, ticket => {
                _.each(ticket.ticket_expenses, expense => {
                    if (expense.currency === 'GBP') {
                        summed += expense.amount;
                    }
                });
            });

            return '£' + (summed / 100);
        },

        jpyExpensesSummed() {
            let summed = 0;

            _.each(this.ticketWithExpensesConvertedIntoJpy, ticket => {
                _.each(ticket.ticket_expenses, expense => {
                    if (expense.currency === 'JPY') {
                        summed += expense.amount;
                    }
                });
            });

            return '¥' + Math.round(summed / 100);
        },

        audExpensesSummed() {
            let summed = 0;

            _.each(this.ticketWithExpensesConvertedIntoJpy, ticket => {
                _.each(ticket.ticket_expenses, expense => {
                    if (expense.currency === 'AUD') {
                        summed += expense.amount;
                    }
                });
            });

            return 'AU$' + (summed / 100);
        },

        usdExpensesSummed() {
            let summed = 0;

            _.each(this.ticketWithExpensesConvertedIntoJpy, ticket => {
                _.each(ticket.ticket_expenses, expense => {
                    if (expense.currency === 'USD') {
                        summed += expense.amount;
                    }
                });
            });

            return '$' + (summed / 100);
        },

        allConvertedExpensesInGbp() {
            let expenses = [];
            _.each(this.ticketWithExpensesConvertedIntoGbp, ticket => {
                _.each(ticket.ticket_expenses, expense => {
                    expenses.push(expense);
                });
            });
            return expenses;
        },

        allConvertedExpensesInJpy() {
            let expenses = [];
            _.each(this.ticketWithExpensesConvertedIntoJpy, ticket => {
                _.each(ticket.ticket_expenses, expense => {
                    expenses.push(expense);
                });
            });
            return expenses;
        },

        dayBins() {
            if (!this.allConvertedExpensesInGbp.length) {
                return [];
            }

            let earliestDateFromResults = _.minBy(this.allConvertedExpensesInGbp, expense => {
                return expense.created_at;
            }).created_at;

            let latestDateFromResults = _.maxBy(this.allConvertedExpensesInGbp, expense => {
                return expense.created_at;
            }).created_at;

            let bins = [];
            let currentDate = moment.utc(earliestDateFromResults).tz(window.itgTimezone).startOf('day');
            let latestDate = moment.utc(latestDateFromResults).tz(window.itgTimezone).endOf('day');

            while (currentDate.isSameOrBefore(latestDate)) {
                bins.push(currentDate.format('YYYY-MM-DD'));
                currentDate.add(1, 'day');
            }

            return bins;
        },

        expensesOverTimeData() {
            let counts = [];

            // number formatter
            let nf = new Intl.NumberFormat('en-GB', {
                style: 'currency',
                currency: 'GBP',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });

            _.each(this.dayBins, day => {
                counts.push({
                    day: day,
                    label: moment(day).format('MMM Do'),
                    GBP: Math.round(this.determineTotalExpensesForDayInGbp(day)) / 100,
                    total_in_gbp_formatted: nf.format(this.determineTotalExpensesForDayInGbp(day) / 100)
                });
            });
            return counts;
        },

        expensesByPrimaryAgent() {
            let counts = [];
            _.each(this.agentsToShow, agent => {
                counts.push({
                    name: agent.name,
                    GBP: this.determineTotalExpensesForPrimaryAgentInGbp(agent) / 100
                });
            });
            return counts;
        }
    }
}
</script>

<style scoped lang="scss">
.conversion-rates {
    display: flex;
    padding: 15px;
    border-radius: 5px;
    background: #F5F7FA;
    margin-bottom: 20px;

    .conversion-rate {
        display: flex;
        align-items: center;
        margin-right: 30px;

        label {
            margin-right: 10px;
            width: 115px;
            margin-bottom: 0;
            padding-bottom: 0;
        }
    }

    .actions {
        flex-grow: 1;
        text-align: right;
    }
}

.summary {
    .card {
        background: #ebeff3;
    }
}
</style>